import { Component, OnInit } from "@angular/core";
import { AppointmentService } from "../../appointment-service/appointment.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { AppontmentlocalService } from "../../appointment-service/appontmentlocal.service";
@Component({
  selector: "app-patient-appointment",
  templateUrl: "./patient-appointment.component.html",
  styleUrls: ["./patient-appointment.component.css"],
})
export class PatientAppointmentComponent implements OnInit {
  appArray = [];
  token: string;
  id: any;
  date4: Date = new Date();
  isData = false;
  isCross: boolean = false;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  totalItems: number = 0;
  page: number = 1;

  constructor(
    private appService: AppointmentService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private appLocalService: AppontmentlocalService
  ) {}

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.queryParams["patid"];
    console.log(this.id);
    this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
      this.token = auth._token;
    });
    this.searchAppByDate(1);
    this.initConfig();
  }

  getAppointmentOfPat(page) {
    this.appService
      .getPatientAppointment(this.id, this.token, page)
      .subscribe((res) => {
        this.appArray = res.appArray;
        this.appLocalService.saveAppArray(this.appArray);
        this.isData = this.appArray.length > 0;
        (this.config.currentPage = res.page),
          (this.config.totalItems = res.total);
      });
    }
  onSearchAppointment() {
    if (this.date4) {
      this.searchAppByDate("1");
    }
  }

  onClearFilter() {
    this.date4 = null;
    this.isCross = false;
    this.appArray = this.appLocalService.getAppArray();
  }

  searchAppByDate(page) {
    const appDate = moment(this.date4).format();
    this.appService
      .getPatientAppointmentByDate(appDate, this.id, this.token, page)
      .subscribe((res) => {
        this.isCross = true;
        this.appArray = res.appArray;
        if(this.appArray && this.appArray.length > 0){
          this.isData = true;
        }else{
          this.isData =  false;
        }
        this.page = res.page;
        this.totalItems = res.total;
        this.initConfig();
      });
  }

  initConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: this.page,
      totalItems: this.totalItems,
    };
  }
  pageChanged(event) {
    this.config.currentPage = event;
    if (this.date4) {
      this.searchAppByDate(this.config.currentPage);
    } else {
      this.getAppointmentOfPat(this.config.currentPage);
    }
  }
}
